import { useConfigContext } from '@sorare/core/src/contexts/config';

const JONUM_LABEL = 'JONUM';

export const isJonumArticle = (labels: string[]) =>
  labels.some(label => label.toUpperCase() === JONUM_LABEL);

export const isJonumSection = (name: string) => /jonum/i.test(name);

export const useShowJonumContent = () => {
  const {
    currentLocation: { countryCode },
  } = useConfigContext();
  return countryCode?.toUpperCase() === 'FR';
};
